import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcBadMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10,
		r: 10,
		fill: "#454952"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 10H15",
		stroke: "#F2F4F8",
		strokeWidth: 1.8,
		strokeLinecap: "round"
	})]
});
export default SvgIcBadMark;
